// NATIVE

// INSTALLED

// CUSTOM
import { checkingPreload, unCheckingPreload } from '../loading';
import { setTipoNovedadesRedux, storeTipoNovedadRedux } from './TipoNovedadSlice';
import {
  activeTipoNovedadService,
  createTipoNovedadService,
  desactiveTipoNovedadService,
  getAllTipoNovedadesByPaginateService,
  getAllTipoNovedadService,
  getDataCreateTipoNovedadService,
  getTipoNovedadDetailService,
  updateTipoNovedadDetailService,
} from '../../services/tiponovedad.service';
import { storeActionTipoNovedadSelectRedux } from '../action_type_new';
import { storeResultTipoNovedadSelectRedux } from '../result_type_new';

export const getTipoNovedadStore = (): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    const result = await getAllTipoNovedadService();

    dispatch(unCheckingPreload());

    if (result.ok) {
      await dispatch(setTipoNovedadesRedux(result.data));
    }

    return result;
  };
};

export const getDatasCreateTipoNovedadStore = (): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    const result = await getDataCreateTipoNovedadService();

    dispatch(unCheckingPreload());

    if (result.ok) {
      await dispatch(storeActionTipoNovedadSelectRedux(result.data.actionTypeNew));
      await dispatch(storeResultTipoNovedadSelectRedux(result.data.resultTypeNew));
    }

    return result;
  };
};

export const storeCreateTipoNovedad = (tipoNovedad: any, percentage: any): any => {
  return async (dispatch: any) => {
    // Procesar las acciones
    const actions = [];
    let i = 1;

    while (tipoNovedad[`accion_${i}`] !== undefined) {
      if (
        tipoNovedad[`accion_${i}`] !== null &&
        tipoNovedad[`resultado_${i}`] !== null &&
        tipoNovedad[`cantidad_${i}`] !== null &&
        tipoNovedad[`cantidad_${i}`] !== ''
      ) {
        actions.push({
          accion: tipoNovedad[`accion_${i}`],
          resultado: tipoNovedad[`resultado_${i}`],
          cantidad: tipoNovedad[`cantidad_${i}`],
        });
      } // END IF

      i++;
    } // END WHILE

    const dataTipoNovedad = {
      name: tipoNovedad.name,
      description: tipoNovedad.description || '',
      actions,
    };

    const result = await createTipoNovedadService(dataTipoNovedad, percentage);

    if (result.ok) {
      if (Object.keys(result.data).length > 0) {
        if (result.ok) {
          await dispatch(setTipoNovedadesRedux(result.data));
        }
      }
    }

    return result;
  };
};

export const storeDesActiveTipoNovedad = (tipoNovedadId: string): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    const result = await desactiveTipoNovedadService(tipoNovedadId);

    dispatch(unCheckingPreload());

    if (result.ok) {
      await dispatch(setTipoNovedadesRedux(result.data));
    }

    return result;
  };
};

export const storeActiveTipoNovedad = (tipoNovedadId: string): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    const result = await activeTipoNovedadService(tipoNovedadId);

    dispatch(unCheckingPreload());

    if (result.ok) {
      await dispatch(setTipoNovedadesRedux(result.data));
    }

    return result;
  };
};

export const getTipoNovedadByPagination = (page: number): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    const result = await getAllTipoNovedadesByPaginateService(page);

    if (result.ok) {
      await dispatch(setTipoNovedadesRedux(result.data));
    }

    dispatch(unCheckingPreload());

    return result;
  };
};

export const storeDetailTipoNovedad = (tipoNovedadId: string): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    const result = await getTipoNovedadDetailService(tipoNovedadId);

    dispatch(unCheckingPreload());

    if (result.ok) {
      const dataTipoNovedad = {
        id: result.data.typeNovedad.id,
        name: result.data.typeNovedad.name,
        description: result.data.typeNovedad.description,
        items: result.data.typeNovedad.typeNewId,
      };

      await dispatch(storeTipoNovedadRedux(dataTipoNovedad));

      await dispatch(storeActionTipoNovedadSelectRedux(result.data.actionTypeNew));
      await dispatch(storeResultTipoNovedadSelectRedux(result.data.resultTypeNew));
    }

    return result;
  };
};

export const storeEditTipoNovedad = (tipoNovedad: any): any => {
  return async (dispatch: any) => {
    await dispatch(checkingPreload());

    console.log('ferrari ', tipoNovedad);
    // Procesar las acciones
    const actions = [];
    let i = 1;

    while (tipoNovedad[`e_accion_${i}`] !== undefined) {
      const accion = tipoNovedad[`e_accion_${i}`];
      const resultado = tipoNovedad[`e_resultado_${i}`];
      const cantidad = tipoNovedad[`e_cantidad_${i}`];

      if (accion !== null && resultado !== null && cantidad !== null && cantidad !== '') {
        actions.push({
          accion, // ya sin e_
          resultado, // ya sin e_
          cantidad, // ya sin e_
        });
      }
      i++;
    }

    const dataTipoNovedad = {
      tipoNovedadId: tipoNovedad.tipoNovedadId,
      name: tipoNovedad.e_name,
      description: tipoNovedad.e_description ?? '',
      actions,
    };

    const result = await updateTipoNovedadDetailService(dataTipoNovedad);

    dispatch(unCheckingPreload());

    if (result.ok) {
      await dispatch(setTipoNovedadesRedux(result.data));
    }

    return result;
  };
};
